import { Address as ApiAddress } from '../realty/model/Address';
import { defined, evaluate } from '../utility/Control';
import { District } from '../realty/model/District';

const CITY_DISTRICT = '1';

export class Address {
  public streetAddress: string;
  public postalCode: string;
  public postalPlace: string;
  public cityDistrict: string;

  public constructor(apiAddress: ApiAddress) {
    const streetName: string = evaluate(apiAddress, 'street.streetName');
    if (defined(streetName)) {
      this.streetAddress = streetName;
      const addressIdent = apiAddress.ident;
      this.streetAddress += defined(addressIdent.addressNumber) ? ' ' + addressIdent.addressNumber : '';
      this.streetAddress += defined(addressIdent.letter) ? ' ' + addressIdent.letter : '';
    }
    this.postalCode = apiAddress.street.postalCode.toString();
    this.postalPlace = apiAddress.street.postalPlace;
    const districts: District[] = evaluate(apiAddress, 'inclusions.districts.items');
    if (defined(districts)) {
      for (let i = 0; i < districts.length; ++i) {
        if (districts[i].ident.districtCode.code === CITY_DISTRICT) {
          this.cityDistrict = districts[i].districtName;
          break;
        }
      }
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/model/Address.ts
 **/